import { call, put, takeEvery } from "redux-saga/effects";
import {
  getCampaignMediaBuyersList,
  hideCampaignMediaBuyersListLoader,
  setCampaignMediaBuyerProfile,
  setCampaignMediaBuyersList,
  setCampaignMediaBuyerUsersInfo,
  setErrorCampaignMediaBuyerProfile,
  showCampaignMediaBuyersListLoader
} from "./actions";
import {
  ADD_CAMPAIGN_MEDIA_BUYERS,
  DELETE_CAMPAIGN_MEDIA_BUYERS,
  GET_CAMPAIGN_MEDIA_BUYER_PROFILE,
  GET_CAMPAIGN_MEDIA_BUYERS_LIST,
  UPDATE_CAMPAIGN_MEDIA_BUYER_PROFILE
} from "./actionTypes";
import {
  deleteCampaignMediaBuyer,
  getCampaignMediaBuyerParams,
  getCampaignMediaBuyerProfile,
  getUsersList,
  postCampaignMediaBuyer,
  putCampaignMediaBuyerProfile
} from "../../../helpers/jwt_helper";
import { getErrorMessage, showErrorMessage, showSuccessMessage } from "../../../helpers/utils";

// Chat Redux States
function* onGetCampaignMediaBuyerList({ payload: data }) {
  try {
    yield put(showCampaignMediaBuyersListLoader());
    let response = yield call(getCampaignMediaBuyerParams, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search,
      // is_active: data.is_active,
    });
    let usersInfo = yield call(getUsersList, {size: 0})
    yield put(setCampaignMediaBuyerUsersInfo(
      usersInfo.map(item => {
        return { label: item.email, value: item.id }
      })))

    // response.results.forEach(item => {
    //   item.user = usersInfo.find(user => user.id === item.user).email
    // })

    response = {
      ...data,
      ...response,
    };

    yield put(setCampaignMediaBuyersList(response));
    yield put(hideCampaignMediaBuyersListLoader());
  } catch (error) {
    yield put(hideCampaignMediaBuyersListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onAddCampaignMediaBuyer({ payload: {mediaBuyer, data } }) {
  try {
    yield put(showCampaignMediaBuyersListLoader());
    yield call(postCampaignMediaBuyer, {
      number: mediaBuyer.number,
      user: mediaBuyer.user
    });
    yield call(onGetCampaignMediaBuyerList, { payload: data });
    yield put(hideCampaignMediaBuyersListLoader());
    showSuccessMessage("Campaign media buyer has been added");
  } catch (error) {
    yield put(hideCampaignMediaBuyersListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onDeleteMediaBuyer({ payload: { id, data } }) {
  try {
    yield put(showCampaignMediaBuyersListLoader());
    yield call(deleteCampaignMediaBuyer, id);
    yield call(onGetCampaignMediaBuyerList, { payload: data });
    yield put(hideCampaignMediaBuyersListLoader());
    showSuccessMessage("Campaign media buyer has been deleted");
  } catch (error) {
    yield put(hideCampaignMediaBuyersListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetCampaignMediaBuyerProfile({ payload: id }) {
  try {
    yield put(setErrorCampaignMediaBuyerProfile(false));
    let response = yield call(getCampaignMediaBuyerProfile, id);
    yield put(setCampaignMediaBuyerProfile(response));
    let usersInfo = yield call(getUsersList, {size: 0})
    yield put(setCampaignMediaBuyerUsersInfo(
      usersInfo.map(item => {
        return { label: item.email, value: item.id }
      })))
  } catch (error) {
    if (getErrorMessage(error) === 'Not found.') {
      yield put(setErrorCampaignMediaBuyerProfile(true));
    } else {
      showErrorMessage(getErrorMessage(error));
    }
  }
}

function* onUpdateCampaignMediaBuyerProfile({ payload: {id, mediaBuyer, data } }) {
  try {
    yield put(showCampaignMediaBuyersListLoader());
    yield call(putCampaignMediaBuyerProfile, id, {
      number: mediaBuyer.number,
      user: mediaBuyer.user
    });
    yield call(onGetCampaignMediaBuyerList, { payload: data });
    yield put(hideCampaignMediaBuyersListLoader());
    showSuccessMessage("Campaign media buyer has been updated");
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* campaignMediaBuyerListSaga() {
  yield takeEvery(GET_CAMPAIGN_MEDIA_BUYERS_LIST, onGetCampaignMediaBuyerList);
  yield takeEvery(DELETE_CAMPAIGN_MEDIA_BUYERS, onDeleteMediaBuyer);
  yield takeEvery(ADD_CAMPAIGN_MEDIA_BUYERS, onAddCampaignMediaBuyer);
  yield takeEvery(GET_CAMPAIGN_MEDIA_BUYER_PROFILE, onGetCampaignMediaBuyerProfile);
  yield takeEvery(UPDATE_CAMPAIGN_MEDIA_BUYER_PROFILE, onUpdateCampaignMediaBuyerProfile);
}

export default campaignMediaBuyerListSaga;
